export const getRandomElementName = (): string => {
    const elements = chemicalElements.elements;
    const singleElement = elements[Math.floor(Math.random() * elements.length)];
    return singleElement.name;
};

export const getElementNumber = (elementName: string): number => {
    const elements = chemicalElements.elements;
    const element = elements.find((el) => el.name.toLowerCase() === elementName.toLowerCase());
    if (element) {
        return element.number;
    } else return 0;
};

export const chemicalElements = {
    elements: [
        {
            number: 1,
            symbol: "H",
            name: "Hydrogen",
            atomic_mass: 1.008,
            category: "Nonmetal",
            phase: "Gas",
            discovered: 1766,
        },
        {
            number: 2,
            symbol: "He",
            name: "Helium",
            atomic_mass: 4.003,
            category: "Noble Gas",
            phase: "Gas",
            discovered: 1868,
        },
        {
            number: 3,
            symbol: "Li",
            name: "Lithium",
            atomic_mass: 6.941,
            category: "Alkali Metal",
            phase: "Solid",
            discovered: 1817,
        },
        {
            number: 4,
            symbol: "Be",
            name: "Beryllium",
            atomic_mass: 9.012,
            category: "Alkaline Earth Metal",
            phase: "Solid",
            discovered: 1798,
        },
        {
            number: 5,
            symbol: "B",
            name: "Boron",
            atomic_mass: 10.81,
            category: "Metalloid",
            phase: "Solid",
            discovered: 1808,
        },
        {
            number: 6,
            symbol: "C",
            name: "Carbon",
            atomic_mass: 12.011,
            category: "Nonmetal",
            phase: "Solid",
            discovered: -3750,
        },
        {
            number: 7,
            symbol: "N",
            name: "Nitrogen",
            atomic_mass: 14.007,
            category: "Nonmetal",
            phase: "Gas",
            discovered: 1772,
        },
        {
            number: 8,
            symbol: "O",
            name: "Oxygen",
            atomic_mass: 15.999,
            category: "Nonmetal",
            phase: "Gas",
            discovered: 1774,
        },
        {
            number: 9,
            symbol: "F",
            name: "Fluorine",
            atomic_mass: 18.998,
            category: "Halogen",
            phase: "Gas",
            discovered: 1886,
        },
        {
            number: 10,
            symbol: "Ne",
            name: "Neon",
            atomic_mass: 20.18,
            category: "Noble Gas",
            phase: "Gas",
            discovered: 1898,
        },
        {
            number: 11,
            symbol: "Na",
            name: "Sodium",
            atomic_mass: 22.99,
            category: "Alkali Metal",
            phase: "Solid",
            discovered: 1807,
        },
        {
            number: 12,
            symbol: "Mg",
            name: "Magnesium",
            atomic_mass: 24.305,
            category: "Alkaline Earth Metal",
            phase: "Solid",
            discovered: 1808,
        },
        {
            number: 13,
            symbol: "Al",
            name: "Aluminum",
            atomic_mass: 26.982,
            category: "Post-transition Metal",
            phase: "Solid",
            discovered: 1825,
        },
        {
            number: 14,
            symbol: "Si",
            name: "Silicon",
            atomic_mass: 28.086,
            category: "Metalloid",
            phase: "Solid",
            discovered: 1824,
        },
        {
            number: 15,
            symbol: "P",
            name: "Phosphorus",
            atomic_mass: 30.974,
            category: "Nonmetal",
            phase: "Solid",
            discovered: 1669,
        },
        {
            number: 16,
            symbol: "S",
            name: "Sulfur",
            atomic_mass: 32.065,
            category: "Nonmetal",
            phase: "Solid",
            discovered: -2000,
        },
        {
            number: 17,
            symbol: "Cl",
            name: "Chlorine",
            atomic_mass: 35.453,
            category: "Halogen",
            phase: "Gas",
            discovered: 1774,
        },
        {
            number: 18,
            symbol: "Ar",
            name: "Argon",
            atomic_mass: 39.948,
            category: "Noble Gas",
            phase: "Gas",
            discovered: 1894,
        },
        {
            number: 19,
            symbol: "K",
            name: "Potassium",
            atomic_mass: 39.098,
            category: "Alkali Metal",
            phase: "Solid",
            discovered: 1807,
        },
        {
            number: 20,
            symbol: "Ca",
            name: "Calcium",
            atomic_mass: 40.078,
            category: "Alkaline Earth Metal",
            phase: "Solid",
            discovered: 1808,
        },
        {
            number: 26,
            symbol: "Fe",
            name: "Iron",
            atomic_mass: 55.845,
            category: "Transition Metal",
            phase: "Solid",
            discovered: -5000,
        },
        {
            number: 29,
            symbol: "Cu",
            name: "Copper",
            atomic_mass: 63.546,
            category: "Transition Metal",
            phase: "Solid",
            discovered: -9000,
        },
        {
            number: 30,
            symbol: "Zn",
            name: "Zinc",
            atomic_mass: 65.38,
            category: "Transition Metal",
            phase: "Solid",
            discovered: 1746,
        },
        {
            number: 47,
            symbol: "Ag",
            name: "Silver",
            atomic_mass: 107.868,
            category: "Transition Metal",
            phase: "Solid",
            discovered: -5000,
        },
        {
            number: 79,
            symbol: "Au",
            name: "Gold",
            atomic_mass: 196.967,
            category: "Transition Metal",
            phase: "Solid",
            discovered: -6000,
        },
    ],
};
